import React, { useContext } from 'react';
import UFOLoadHold from '../load-hold';
import { LazySuspense, WaitContext } from './loosely-lazy';

/**
 * Provides a placeholder for lazily loaded content, improving perceived performance.
 *
 * Named placeholders are especially useful for analyzing page load breakdowns
 * in performance monitoring tools like Performance Portal.
 */
export default function Placeholder(_ref) {
  var name = _ref.name,
    children = _ref.children,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback;
  var waitContext = useContext(WaitContext);
  var shouldHold = !waitContext || !!waitContext.currentValue();
  return /*#__PURE__*/React.createElement(LazySuspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null, fallback, /*#__PURE__*/React.createElement(UFOLoadHold, {
      name: name,
      hold: shouldHold
    })),
    name: name
  }, children);
}